module.exports = __webpack_public_path__ + "media/Sworn to Protect (the Zegeans).72485512.mp3";